<div class="com-pro">
    <div class="tile" *ngIf="masterMapData?.length">
        <app-leaflet-map pageType="profile" [mapData]="masterMapData"></app-leaflet-map>
    </div>
    <div class="tile">
        <div class="tile-title">
            <h5 class="l-space-between-containers"><strong>KM/L</strong></h5>
        </div>
        <div class="tile-chart-area" *ngIf="mileage?.length">
            <app-plotly-line [lineData]="mileage"></app-plotly-line>
        </div>
    </div>
    <div class="tile">
        <div class="tile-title">
            <h5 class="l-space-between-containers"><strong>AVG SPEED</strong></h5>
        </div>
        <div class="tile-chart-area" *ngIf="speed?.length">
            <app-plotly-line [lineData]="speed"></app-plotly-line>
        </div>
    </div>
    <div class="tile">
        <div class="tile-title">
            <h5 class="l-space-between-containers"><strong>FUEL CONSUMED</strong></h5>
        </div>
        <div class="tile-chart-area" *ngIf="fuel?.length">
            <app-plotly-line [lineData]="fuel"></app-plotly-line>
        </div>
    </div>
</div>